import { useFilters } from '@statsbomb/kitbag-global-football';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { METRIC_KEY } from '@/consts/searchKeys';
import { useMetricKeyFilter } from '@/hooks/useMetricKeyFilter';

export const useSetMetricKey = () => {
  const [searchParams] = useSearchParams();
  const { setMetricKey } = useMetricKeyFilter();

  const [filters] = useFilters('main');
  const metricKey = filters.metric;
  const metricKeyParam = searchParams.get(METRIC_KEY);

  useEffect(() => {
    if (metricKeyParam && metricKeyParam !== metricKey) {
      setMetricKey(metricKeyParam);
    }
  }, [metricKeyParam, metricKey, setMetricKey]);
};
